module.exports = __webpack_public_path__ + "gardensc-webfont.3edcb9d75757af8b70c7.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/gardensc-webfont.woff
// module id = ./src/assets/webfonts/gardensc-webfont.woff
// module chunks = styles